import React from 'react';
import styles from './SocialHandles.module.css';
import { useTheme } from '../../basic/ThemeProvider';

interface SocialHandlesProps {
  height?: number;
}

const SocialHandles: React.FC<SocialHandlesProps> = ({ height = 24 }) => {
  const itemStyle: React.CSSProperties = { height, width: 'auto' };
  const { isDark } = useTheme();
  const theme = isDark ? 'dark' : 'light';
  return (
    <nav className={styles.container} aria-label="Social links">
      <a
        className={styles.link}
        href="https://x.com/v_monad"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="vMonad on X"
      >
        <img src={`/game/socials/${theme}/x.png`} alt="X handle" style={itemStyle} />
      </a>
      <a
        className={styles.link}
        href="https://instagram.com/vmonad"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="vMonad on Instagram"
      >
        <img src={`/game/socials/${theme}/instagram.png`} alt="Instagram handle" style={itemStyle} />
      </a>
      <a
        className={styles.link}
        href="https://youtube.com/@vmonad"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="vMonad on YouTube"
      >
        <img src={`/game/socials/${theme}/youtube.png`} alt="YouTube handle" style={itemStyle} />
      </a>
    </nav>
  );
};

export default SocialHandles;
